import envConfig from '../../utils/envConfig'

export const ChosenBackend = () => {
    const defaultBackend = envConfig[process.env.REACT_APP_ENVIRONMENT]['graphql_default']
    return (envConfig[process.env.REACT_APP_ENVIRONMENT][defaultBackend])
}
